module.exports = __webpack_public_path__ + "img/LOST-Live-V.03894af5.jpg";